export {
  certificatesApi,
  useGetCertificatesQuery,
  useLazyGetCertificatesQuery,
  useLazyGetCertificateByIdQuery,
  useCreateCertificateMutation,
  useEditCertificateMutation,
  useDeleteCertificateMutation,
  useLazyGetCertificatesForSaleQuery,
} from './api';
export {
  CertificatesEndpoints,
  type ModelCertificate,
  type ModelRecordCertificate,
  type GetCertificatesForSaleRequest,
  type GetCertificatesForSaleResponse,
  type GetCertificatesRequest,
  type GetCertificatesResponse,
  type GetCertificateByIdRequest,
  type GetCertificateByIdResponse,
  type CreateCertificateRequest,
  type CreateCertificateResponse,
  type EditCertificateRequest,
  type EditCertificateResponse,
  type DeleteCertificateRequest,
  type DeleteCertificateResponse,
} from './types';
